const OtherCityName = ({cityName})=>{
    return (
        <div className="tracking-wider w-[120px] font-bold text-left">
            {cityName}
        </div>
    )
}

export default OtherCityName